<template>
  <div class="modal" ref="modal" id="modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-4 border-ccs ccs-card-radius p-3">
        <div class="modal-header pt-0 mb-0">
          <button type="button" class="modal-close" data-bs-dismiss="modal">
            {{ $t('wz_case_form.btn_close') }}
            <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071Z" fill="#23AE84"></path> </g></svg>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-0"><b>{{$t('wz_case_form.wz2_form.warning_start')}}</b>{{ message }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {Modal} from "bootstrap";

export default {
  name: "AdditionalInfoModal",
  data() {
    return {
      showModal: true
    }
  },
  props: {
    message: String
  },
  mounted() {
    this.modal = new Modal(this.$refs.modal);
  },
  methods: {
    show: function () {
      this.modal.show();
    },
  },

}
</script>

<style scoped>
.modal-header .modal-close {
  font-family: Mulish;
  color: #23AE84;
  font-size: 16px;
  background: none;
  border: none;
  font-weight: bold;
}
.modal-header .modal-close {
  margin-left: auto;
  order: 2;
}
.modal-body {
  align-content: center;
  text-align: center;
}

</style>